import { DollarSignIcon, KeyRound } from "lucide-react";
import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList } from "../../../../components/links/Links";
import LogoutModal from "../../../../pages/Login/LogoutModal";
import CostPlusEditModal from "../../../../pages/PriceCompare/CostPlusEditModal";
import ChangePasswordModal from "../../../../pages/Users/ChangePasswordModal";
import UserAlert from "../../../../pages/Users/UserAlert";
import { useUserInfo } from "../../../provider/Theme";
const User = () => {
  const [open, setOpen] = useState(false);
  const [logout, setLogout] = useState(false);
  const { userInfo } = useUserInfo();
  const handleLogout = (value) => {
    setLogout(value);
  };
  const toggle = () => setOpen((prevState) => !prevState);

  const [modal, setModal] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  // const [mutation, setMutation] = useState({});
  const handleChangePassword = (value) => {
    setChangePassword(value);
  };
  // Extract values from settingsData and set defaults

  const [alertModal, setAlertModal] = useState(false);
  const handleUserAlertForPasswordChange = (value) => {
    setAlertModal(value);
  };
  const handelModal = (value) => {
    setModal(value);
  };
  const handleSetMutation = () => {
    // setMutation({});
  };
  return (
    <div>
      <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
        <DropdownToggle
          tag="a"
          href="#toggle"
          className="dropdown-toggle"
          onClick={(ev) => {
            ev.preventDefault();
          }}
        >
          <div className="user-toggle">
            <div className="user-avatar">
              <span>{userInfo?.name[0]}</span>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
          <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
            <div className="user-card sm">
              <div className="user-avatar">
                <span>{userInfo?.name[0]}</span>
              </div>
              <div className="user-info">
                <span className="lead-text">{userInfo?.name}</span>
                <span className="sub-text">{userInfo?.email}</span>
              </div>
              {/* <div className="user-action" onClick={() => setOpen(false)}>
                <Link
                  to={`${process.env.PUBLIC_URL}/user-profile-setting`}
                  className="btn btn-icon me-n2"
                >
                  <Icon name="setting" />
                </Link>
              </div> */}
            </div>
          </div>

          <div className="dropdown-inner">
            <LinkList>
              {(userInfo?.role === "super-admin" ||
                userInfo?.role === "admin") && (
                <div
                  className={`${
                    userInfo?.role === "super-admin" ||
                    userInfo?.role === "admin"
                      ? "py-2"
                      : ""
                  } `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      userInfo?.role === "super-admin" ||
                      userInfo?.role === "admin"
                    ) {
                      handelModal(true);
                      // toggle();
                    } else {
                      // handleUserAlertForPasswordChange(true);
                    }
                  }}
                >
                  <DollarSignIcon size={14} />
                  <span className=" ps-1">Update Cost Plus Value</span>
                </div>
              )}
              <div
                className={`${
                  userInfo?.role === "super-admin" || userInfo?.role === "admin"
                    ? "py-2"
                    : ""
                } `}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (userInfo?.role === "super-admin") {
                    handleChangePassword(true);
                    // toggle();
                  } else {
                    handleUserAlertForPasswordChange(true);
                  }
                }}
              >
                <KeyRound size={14} />
                <span className=" ps-1">Change Password</span>
              </div>
            </LinkList>
          </div>
          <div className="dropdown-inner">
            <LinkList>
              <div
                className=" "
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleLogout(true);
                }}
              >
                <Icon name="signout"></Icon>
                <span className=" ps-1">Sign Out</span>
              </div>
            </LinkList>
          </div>
        </DropdownMenu>
      </Dropdown>
      <LogoutModal handelModal={handleLogout} modal={logout} />
      <ChangePasswordModal
        modalForm={changePassword}
        setModalForm={handleChangePassword}
      />
      <UserAlert
        message={"Please contact the Administrator to reset your password."}
        handelModal={handleUserAlertForPasswordChange}
        modal={alertModal}
      />
      <CostPlusEditModal
        modalForm={modal}
        setModalForm={handelModal}
        userData={{
          setMutationCall: handleSetMutation,
        }}
        isComparePage={false}
        updateCostPlus={true}
      />
    </div>
  );
};

export default User;
